var map = {
	"./Emblem_BRONZE.png": 560,
	"./Emblem_CHALLENGER.png": 57,
	"./Emblem_DIAMOND.png": 963,
	"./Emblem_GOLD.png": 574,
	"./Emblem_GRANDMASTER.png": 372,
	"./Emblem_IRON.png": 779,
	"./Emblem_MASTER.png": 641,
	"./Emblem_PLATINUM.png": 646,
	"./Emblem_SILVER.png": 770,
	"./Emblem_UNRANKED.png": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 915;